<div>
  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="z-index: 1000; position: relative;"
      [isInboxPresent]="true"
      [isCompanyProfile]="true"
      [isAgencyProfile]="true"
      [isProfile]="false"
      [isMobile]="isMobile"
      [showButtons]="false"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>
</div>

<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="page-content">
    <div class="dashboard-header">
      <div class="title">
        {{ 'candidates.title' | translate }} <span class="count">: {{ candidates.length }}</span>
      </div>

      <div style="padding-bottom: 1rem;">
        <app-button
          [isFullWidth]="true"
          (click)="addNewCandidate()"
          [label]="'candidates.add_new' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY"
        ></app-button>
      </div>
    </div>

    <div class="dashboard-container">
      <!-- Sidebar -->
      <div class="sidebar">
        <input
          class="search-input"
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          [placeholder]="'candidates.search' | translate"
        />
        <ul class="candidate-list">
          <li
            *ngFor="let candidate of candidates"
            [class.active]="candidate.id === selectedCandidate?.id"
            (click)="selectCandidate(candidate)"
          >
            <img [src]="candidate.profileImageUrl" alt="avatar" class="avatar"/>
            <span>{{ candidate?.firstname }} {{ candidate?.lastname }}</span>
          </li>
        </ul>
      </div>

      <!-- Right Panel -->
      <div class="detail-panel">
        <ng-container *ngIf="candidates.length > 0; else emptyState">
          <div class="detail-header">
            <div class="info">
              <div class="avatar-wrapper">
                <img [src]="selectedCandidate?.profileImageUrl" alt="profile" class="avatar-large"/>
                <img src="assets/upload.svg"
                     alt="Update"
                     class="photo-update-icon"
                     (click)="fileInput.click()">

                <input type="file" #fileInput (change)="onFileSelected($event, selectedCandidate.id)" hidden>
              </div>
              <div>
                <h2>{{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</h2>
                <span class="flag-emoji">{{ getFlagEmoji(selectedCandidate?.location) }}</span>
                <span class="country text-gray-700">{{ selectedCandidate?.location }}</span>
              </div>
            </div>
            <div class="actions">
              <app-button
                [isFullWidth]="true"
                [label]="'candidates.edit' | translate"
                (click)="editCandidate(selectedCandidate)"
                [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR"
                [type]="ButtonType.SECONDARY"
              ></app-button>
              <app-button
                [isFullWidth]="true"
                (click)="deleteCandidate(selectedCandidate?.id)"
                [label]="'candidates.delete' | translate"
                [size]="ButtonSize.LARGE"
                [state]="ButtonState.REGULAR"
                [type]="ButtonType.GHOST"
              ></app-button>
            </div>
          </div>

          <div class="tabs">
            <span class="tab" [class.active]="selectedTab === 'profile'" (click)="selectedTab = 'profile'">
              {{ 'candidates.tabs.profile' | translate }}
            </span>
            <span class="tab" [class.active]="selectedTab === 'documents'" (click)="selectedTab = 'documents'">
              {{ 'candidates.tabs.documents' | translate }}
            </span>
          </div>

          <div class="tab-content">
            <ng-container *ngIf="selectedTab === 'profile'">
              <div class="profile-section-grid" *ngIf="selectedCandidate">

                <!-- Bio -->
                <div class="box">
                  <div class="section-title">{{ 'candidates.bio' | translate }}</div>
                  <div class="section-content">
                    {{ selectedCandidate?.motivation || ('candidates.no_bio' | translate) }}
                  </div>
                </div>

                <!-- Language -->
                <div class="box">
                  <div class="section-title">{{ 'candidates.language' | translate }}</div>
                  <div class="section-content">
                    <div style="flex-wrap: wrap; gap: 1rem;display: flex;flex-direction: row;"
                         *ngIf="selectedCandidate?.languages?.length; else noLanguages">
                      <div *ngFor="let lang of selectedCandidate?.languages" class="language-chip">
                        <img [src]="getFlagSrc(lang)" class="flag-icon"/>
                        <span class="language-name">{{ lang }}</span>
                      </div>
                    </div>
                    <ng-template #noLanguages>
                      <div class="empty-data-message">{{ 'candidates.no_languages' | translate }}</div>
                    </ng-template>
                  </div>
                </div>

                <!-- Experience -->
                <div class="box">
                  <div class="section-title">{{ 'candidates.experience' | translate }}</div>
                  <div class="section-content">
                    <ng-container *ngIf="selectedCandidate?.workExperience?.length > 0; else noExperience">
                      <div *ngFor="let exp of selectedCandidate.workExperience" class="experience-entry">
                        <strong>
                          {{ exp.startDate | date: 'MM/yyyy' }} -
                          {{ exp.completionDate ? (exp.completionDate | date: 'MM/yyyy') : ('candidates.present' | translate) }}
                        </strong>
                        <ul>
                          <li *ngFor="let line of exp.jobDescription?.split('\n')">{{ line }}</li>
                        </ul>
                      </div>
                    </ng-container>
                    <ng-template #noExperience>
                      <div class="empty-data-message">{{ 'candidates.no_experience' | translate }}</div>
                    </ng-template>
                  </div>
                </div>

                <!-- Education -->
                <div class="box">
                  <div class="section-title">{{ 'candidates.education' | translate }}</div>
                  <div class="section-content">
                    <ng-container *ngIf="selectedCandidate?.education?.length > 0; else noEducation">
                      <div *ngFor="let edu of selectedCandidate.education" class="experience-entry">
                        <strong>{{ edu.education }}</strong><br/>
                        <span>{{ edu.organization }}</span><br/>
                        <span>
          <!-- from (start) -->
                          {{ edu.startDate ? (edu.startDate | date:'MM/yyyy') + ' - ' : '' }}
                          <!-- to (end) -->
                          {{ edu.completionDate ? (edu.completionDate | date:'MM/yyyy') : ('candidates.present' | translate) }}
        </span>
                      </div>
                    </ng-container>
                    <ng-template #noEducation>
                      <div class="empty-data-message">{{ 'candidates.no_education' | translate }}</div>
                    </ng-template>
                  </div>
                </div>

              </div>
            </ng-container>


            <ng-container *ngIf="selectedTab === 'documents'">
              <div style="display: flex;justify-content: space-between;">
                <h3>{{ 'candidates.documents_list' | translate }}</h3>
                <app-button
                  style="padding-bottom: 1.5rem;"
                  [label]="'candidates.add_document' | translate"
                  (click)="openCertificateListDialog()"
                  [size]="ButtonSize.SMALL"
                  [state]="ButtonState.REGULAR"
                  [type]="ButtonType.SECONDARY"
                ></app-button>
              </div>
              <div class="document-card" *ngFor="let material of selectedCandidate.materials;">
                <div class="doc-row">
                  <div class="doc-info">
                    <div class="doc-title">
                      {{ material.title || material.type }}
                      <span class="type-chip">{{ material.type || 'DOC' }}</span>
                    </div>
                  </div>

                </div>

                <!-- ORIGINAL (always) -->
                <div class="file-row" *ngIf="getOriginalRow(material.id) as row">
                  <img class="filetype-icon"
                       [src]="fileIcon(row.contentType) === 'pdf' ? 'assets/pdf.png' : 'assets/doc.png'"
                       [alt]="fileIcon(row.contentType) === 'pdf' ? 'PDF' : 'DOC'"/>

                  <div class="file-col">
                    <div class="filename">{{ row.name }}</div>
                    <div class="meta">
                      {{ row.label }} :
                      <ng-container *ngIf="row.when; else noDateOrig">
                        {{ row.when | date:'MMMM d, y, hh:mm a' }}
                      </ng-container>
                      <ng-template #noDateOrig>—</ng-template>
                    </div>
                  </div>

                  <div class="doc-actions">
                    <button class="translate-button"
                            [class.disabled]="hasTranslation(material.id)"
                            [disabled]="hasTranslation(material.id)"
                            (click)="!hasTranslation(material.id) && openTranslateModule(material)">
                      <img src="assets/translate.svg" alt="Translate"/>
                    </button>

                    <button class="icon-button" (click)="downloadMaterial(material)">
                      <img src="assets/download.svg" alt="Download"/>
                    </button>
                    <button class="icon-button" (click)="viewMaterial(material)">
                      <img src="assets/view.png" alt="View"/>
                    </button>
                    <button class="icon-button" (click)="deleteMaterial(material)">
                      <img src="assets/garbadge.png" alt="Delete"/>
                    </button>
                  </div>

                </div>

                <!-- TRANSLATION rows (only if present) -->
                <ng-container *ngIf="hasTranslation(material.id)">
                  <div class="file-row" *ngFor="let row of getTranslationRows(material.id)">
                    <img class="filetype-icon"
                         [src]="fileIcon(row.contentType) === 'pdf' ? 'assets/pdf.png' : 'assets/doc.png'"
                         [alt]="fileIcon(row.contentType) === 'pdf' ? 'PDF' : 'DOC'"/>

                    <div class="file-col">
                      <div class="filename">{{ row.name }}</div>
                      <div class="meta">
                        {{ row.label }} :
                        <ng-container *ngIf="row.when; else noDateTr">
                          {{ row.when | date:'MMMM d, y, hh:mm a' }}
                        </ng-container>
                        <ng-template #noDateTr>—</ng-template>
                      </div>
                    </div>

                    <div class="doc-actions">

                      <button class="icon-button" (click)="downloadUrl(row.url, row.name, row.contentType)">
                        <img src="assets/download.svg" alt="Download"/>
                      </button>
                      <button class="icon-button" (click)="downloadUrl(row.url, row.name, row.contentType)">
                        <img src="assets/view.png" alt="View"/>
                      </button>
                      <button class="icon-button" (click)="deleteMaterial(material)">
                        <img src="assets/garbadge.png" alt="Delete"/>
                      </button>
                    </div>

                  </div>
                </ng-container>

                <!-- VERIFIED rows (if any) -->
                <div class="file-row" *ngFor="let row of getSignedRows(material.id)">
                  <img class="filetype-icon"
                       [src]="fileIcon(row.contentType) === 'pdf' ? 'assets/pdf.png' : 'assets/doc.png'"
                       [alt]="fileIcon(row.contentType) === 'pdf' ? 'PDF' : 'DOC'"/>
                  <div class="file-col">
                    <div class="filename">{{ row.name }}</div>
                    <div class="meta">
                      {{ row.label }} :
                      <ng-container *ngIf="row.when; else noDateSigned">
                        {{ row.when | date:'MMMM d, y, hh:mm a' }}
                      </ng-container>
                      <ng-template #noDateSigned>—</ng-template>
                    </div>
                  </div>
                  <div class="row-actions">
                    <button class="icon-button" (click)="downloadUrl(row.url, row.name, row.contentType)">
                      <img src="assets/download.svg" alt="Download"/>
                    </button>
                    <button class="icon-button" (click)="downloadUrl(row.url, row.name, row.contentType)">
                      <img src="assets/view.png" alt="View"/>
                    </button>
                    <button class="icon-button" (click)="deleteMaterial(material)">
                      <img src="assets/garbadge.png" alt="Delete"/>
                    </button>
                  </div>
                </div>

                <!-- Upload Verified & signed (visible once translation exists) -->
                <div class="verified-box" *ngIf="hasTranslation(material.id)">
                  <div class="vb-title">Verified & signed document</div>

                  <button class="vb-drop full-width-btn" (click)="openSignedUploadDialog(material)">
                    <span class="vb-plus">+</span>
                    <span>Drop your file here</span>
                  </button>

                  <div class="vb-hint">Only PDF format accepted</div>
                </div>

              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #emptyState>
          <div class="empty-state-content">
            <img src="assets/no-candidage.png" alt="empty"/>
            <p>{{ 'candidates.empty_message' | translate }}</p>
            <app-button
              [label]="'candidates.new_candidate' | translate"
              (click)="addNewCandidate()"
              [size]="ButtonSize.LARGE"
              [state]="ButtonState.REGULAR"
              [type]="ButtonType.PRIMARY"
            ></app-button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="footer-class">
    <div class="footer-container">
      <app-footer></app-footer>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
